window.NORTHY_CLUBFIT = {
  "checkedOn": "2026-10-19",
  "ptBooking": {
    "checkedOn": "2026-10-19",
    "trainers": ["Jesse Edwards", "Brodie Robertson"],
    "source": "Clubfit External Links > Book me; public PT Session trainer chooser",
    "flow": "Select PT Session, choose a trainer, then choose the date and duration. Availability and booking eligibility are handled by Clubfit.",
    "trainerSpecificLinksVerified": false
  },
  "holidayPassIds": ["126"],
  "freeGuestClasses": [
    {"name":"30 Min Ignite","clubfitName":"30 MIN IGNITE","times":"Thursday 6:15 pm · Sunday 3:45 pm","duration":"30 minutes","scheduleIds":[109,142],"sessionButtons":["Thursday · 6:15 pm","Sunday · 3:45 pm"]},
    {"name":"Tabata","clubfitName":"TABATA","times":"Thursday 9:30 am","duration":"60 minutes","scheduleIds":[108],"sessionButtons":["Thursday · 9:30 am"]},
    {"name":"Thursday Pilates","clubfitName":"Reformer Open","times":"Thursday 7:00 pm","duration":"45 minutes","scheduleIds":[156],"sessionButtons":["Thursday · 7:00 pm"]}
  ],
  "fees": {
    "weeklyBankDebitCents": 160,
    "source": "Clubfit Settings > Billing > Gym > Weekly Gym Bank Transaction Fee",
    "checkedOn": "2026-10-16",
    "scope": "Weekly bank debit only; card and upfront transaction charges have not been verified."
  },
  "source": "Clubfit North Nowra membership and external link settings",
  "links": {
    "weeklyTimetable": "https://myaccount.clubfit.net.au/groupfitness/weekly?code=NORTHYGYM&accountId=1",
    "classes": "https://myaccount.clubfit.net.au/groupfitness?code=NORTHYGYM&accountId=1",
    "bookings": "https://myaccount.clubfit.net.au/bookme?code=NORTHYGYM&accountId=1",
    "memberships": "https://myaccount.clubfit.net.au/onlineoffers?code=NORTHYGYM&accountId=1&source=online",
    "enquiry": "https://myaccount.clubfit.net.au/prospect-inquiry?code=NORTHYGYM&accountId=1",
    "trial": "https://myaccount.clubfit.net.au/prospect-inquiry?code=NORTHYGYM&accountId=1&trial=true",
    "casualVisit": "https://myaccount.clubfit.net.au/prospect-casual-visit?code=NORTHYGYM&accountId=1",
    "tour": "https://myaccount.clubfit.net.au/prospect-tour-booking?code=NORTHYGYM&accountId=1",
    "memberLogin": "https://myaccount.clubfit.net.au/signin/1?code=NORTHYGYM&accountId=1",
    "shop": "https://myaccount.clubfit.net.au/signin/1?code=NORTHYGYM&accountId=1&redirect=shop"
  },
  "memberships": [
    {
      "id": "105",
      "name": "1 Month Adult Membership",
      "department": "Gym",
      "term": "1 Month /s",
      "amount": "$149.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/105?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/105?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "102",
      "name": "1 Month Student and Pensioner",
      "department": "Gym",
      "term": "1 Month /s",
      "amount": "$131.50",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": true,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/102?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/102?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "126",
      "name": "1 Week Northy classes & weights",
      "department": "Gym",
      "term": "1 Week /s",
      "amount": "$63.50",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "pass",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/126?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/126?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "196",
      "name": "10 Adult Visit Pass",
      "department": "Gym",
      "term": "10 Visit(s)",
      "amount": "$160.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "pass",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/196?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/196?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "199",
      "name": "10 Visit Pass Student and Pensioner",
      "department": "Gym",
      "term": "10 Visit(s)",
      "amount": "$139.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": true,
      "kind": "pass",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/199?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/199?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "110",
      "name": "12 Month Adult Membership",
      "department": "Gym",
      "term": "12 Month /s",
      "amount": "$801.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/110?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/110?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "198",
      "name": "12 Month Student Pensioner Membership",
      "department": "Gym",
      "term": "12 Month /s",
      "amount": "$744.50",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": true,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/198?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/198?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "200",
      "name": "12 Visit Staying Strong",
      "department": "Gym",
      "term": "12 Session(s)",
      "amount": "$107.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "pass",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/200?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/200?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "207",
      "name": "15 Visit Class Pass",
      "department": "Gym",
      "term": "15 Session(s)",
      "amount": "$242.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "pass",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/207?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/207?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "197",
      "name": "20 VISIT ADULT",
      "department": "Gym",
      "term": "20 Visit(s)",
      "amount": "$275.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "pass",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/197?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/197?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "201",
      "name": "20 Visit Pass Student and Pensioner",
      "department": "Gym",
      "term": "20 Visit(s)",
      "amount": "$229.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": true,
      "kind": "pass",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/201?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/201?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "104",
      "name": "3 Month Adult Membership",
      "department": "Gym",
      "term": "3 Month /s",
      "amount": "$378.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/104?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/104?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "140",
      "name": "3 Month Student and Pensioner",
      "department": "Gym",
      "term": "3 Month /s",
      "amount": "$344.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": true,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/140?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/140?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "118",
      "name": "6 Month Adult Membership",
      "department": "Gym",
      "term": "6 Month /s",
      "amount": "$562.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/118?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/118?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "133",
      "name": "6 Month Student and Pensioner",
      "department": "Gym",
      "term": "6 Month /s",
      "amount": "$515.50",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": true,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/133?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/133?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "218",
      "name": "Kids Club",
      "department": "Gym",
      "term": "12 Week /s",
      "amount": "$122.50",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "pass",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/218?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/218?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "155",
      "name": "Northy Flow Reformer & LM ADD-ON",
      "department": "Gym",
      "term": "80 Session(s)",
      "amount": "$51.00",
      "joiningFee": "$0.00",
      "accessCardFee": "$0.00",
      "payment": "upfront",
      "concession": false,
      "kind": "addon",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/155?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/155?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "209",
      "name": "DD 12 Month Student and Pensioner Ongoing",
      "department": "Gym",
      "term": "52 payments\nWeek /s",
      "amount": "$17.31",
      "joiningFee": "$60.00",
      "accessCardFee": "$0.00",
      "payment": "weekly",
      "concession": true,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/209?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/209?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "210",
      "name": "DD 12 Months Adult Ongoing",
      "department": "Gym",
      "term": "52 payments\nWeek /s",
      "amount": "$21.38",
      "joiningFee": "$60.00",
      "accessCardFee": "$0.00",
      "payment": "weekly",
      "concession": false,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/210?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/210?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "107",
      "name": "DD 24 Months Adult",
      "department": "Gym",
      "term": "104 payments\nWeek /s",
      "amount": "$17.64",
      "joiningFee": "$90.00",
      "accessCardFee": "$0.00",
      "payment": "weekly",
      "concession": false,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/107?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/107?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "211",
      "name": "DD 6 Month Adult Ongoing",
      "department": "Gym",
      "term": "26 payments\nWeek /s",
      "amount": "$25.46",
      "joiningFee": "$60.00",
      "accessCardFee": "$0.00",
      "payment": "weekly",
      "concession": false,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/211?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/211?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    },
    {
      "id": "212",
      "name": "DD 6 Month Student and Pensioner Ongoing",
      "department": "Gym",
      "term": "26 payments\nWeek /s",
      "amount": "$21.38",
      "joiningFee": "$60.00",
      "accessCardFee": "$0.00",
      "payment": "weekly",
      "concession": true,
      "kind": "membership",
      "signupUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/212?code=NORTHYGYM&accountId=1&sidebar=true&single=true",
      "iframeUrl": "https://myaccount.clubfit.net.au/onlineoffers/membership/212?code=NORTHYGYM&accountId=1&sidebar=false&single=true",
      "verified": true
    }
  ]
};
